import { generate } from '@/utils/request';
const config = {
  prefix: '/sfin/v1/{organizationId}',
  items: [
    { key: 'ordertypeList', url: '/work/order/type/list', method: 'post' },
    // 获取所有工单管理下拉框 get /v1/{organizationId}/work/order/type/listType 
    { key: 'getWorkOrderAllList', url: '/work/order/type/listType', method: 'get' },
    { key: 'ordertypeAdd', url: '/work/order/type/add', method: 'post' },
    { key: 'ordertypeUpdate', url: '/work/order/type/update', method: 'post' },
    { key: 'enableOrderType', url: '/work/order/type/enable/{code}', method: 'get' },
    { key: 'forbiddenOrderType', url: '/work/order/type/forbidden/{code}', method: 'get' },
    { key: 'getOrderTypeLogsList', url: '/work/order/type/logs/List/{code}', method: 'get' },

    // 工单部门
    { key: 'getConsultationTypeList', url: '/work/consultation/type/list', method: 'get' },

    // 工单列表
    { key: 'getWorkOrderPageList', url: '/work/order/pageInfoListCsg', method: 'post' },
    // 获取工单详情页
    { key: 'getWorkOrderDetail', url: '/work/order/{id}', method: 'get' },
    // 获取工单详情页 User端需要多传个clientCode  ==>>>   GET：/v1/{organizationId}/work/order/{id}/{clientCode}
    { key: 'getWorkOrderDetailUser', url: '/work/order/{id}/{clientCode}', method: 'get' },
    // 新建工单 post /v1/{organizationId}/work/order/new
    { key: 'postNewWorkOrder', url: '/work/order/new', method: 'post' },
    // 修改工单 put /v1/{organizationId}/work/order/modify
    { key: 'modifyWorkOrder', url: '/work/order/modify', method: 'put' },
    // 删除工单 put /v1/{organizationId}/work/order/del/{id}
    { key: 'deleteWorkOrder', url: '/work/order/del/{id}', method: 'put' },
    // 保存并提交工单 post /v1/{organizationId}/work/order/submit
    { key: 'submitWorkOrder', url: '/work/order/submit', method: 'post' },
    // 提交审核 put /v1/{organizationId}/work/order/startAudit/{id}
    { key: 'startAuditWorkOrder', url: '/work/order/startAudit/{id}', method: 'put' },
    // 审核通过 post /v1/{organizationId}/work/order/examinePass 
    { key: 'examinePassWorkOrder', url: '/work/order/examinePass', method: 'post' },
    // 审核不通过 post /v1/{organizationId}/work/order/failTheAudit
    { key: 'failTheAuditWorkOrder', url: '/work/order/failTheAudit', method: 'post' },
    // 审核 指定部门 post /v1/{organizationId}/work/order/modifyDep
    { key: 'modifyDepWorkOrder', url: '/work/order/modifyDep', method: 'put' },
    // 开始处理 get /v1/{organizationId}/work/order/startProcessing/{id}
    { key: 'startProcessingWorkOrder', url: '/work/order/startProcessing/{id}', method: 'get' },
    // 暂停处理 put /v1/{organizationId}/work/order/stop/{id}
    { key: 'stopWorkOrder', url: '/work/order/stop/{id}', method: 'put' },
    // 完成处理 post /v1/{organizationId}/work/order/handle/finish
    { key: 'finishWorkOrder', url: '/work/order/handle/finish', method: 'post' },
    // 确认收费 post /v1/{organizationId}/work/order/sure
    { key: 'sureWorkOrder', url: '/work/order/sure', method: 'post' },
    // 作废 put /v1/{organizationId}/work/order/invalid/{id}
    { key: 'invalidWorkOrder', url: '/work/order/invalid/{id}', method: 'put' },
    // 查询日志 get /v1/{organizationId}/work/order/log/InfoList/{wOrderNo}
    { key: 'workOrderLogs', url: '/work/order/log/InfoList/{wOrderNo}', method: 'get' },
    // 工单聊天备注（左） post /v1/{organizationId}/work/order/remark
    { key: 'workOrderSendRemark', url: '/work/order/remark', method: 'post' },
    // 工单聊天备注（右） post /v1/{organizationId}/work/order/message
    { key: 'workOrderSendMessage', url: '/work/order/message', method: 'post' },

  ],
};

export default {
  ...generate(config),
};
